import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signUp, signInWithGoogle } from '../lib/supabase';

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908C16.658 14.013 17.64 11.706 17.64 9.2z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" fill="#34A853"/>
      <path d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707s.102-1.167.282-1.707V4.961H.957C.347 6.175 0 7.55 0 9s.348 2.825.957 4.039l3.007-2.332z" fill="#FBBC05"/>
      <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.961L3.964 7.293C4.672 5.166 6.656 3.58 9 3.58z" fill="#EA4335"/>
    </svg>
  );
}

export default function Register() {
  const [form, setForm] = useState({ username: '', email: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const navigate = useNavigate();

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) return setError('Passwords do not match.');
    if (form.password.length < 6) return setError('Password must be at least 6 characters.');
    if (!form.username.trim()) return setError('Username is required.');
    setLoading(true);
    try {
      await signUp(form.email, form.password, form.username.trim());
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = async () => {
    setError('');
    setGoogleLoading(true);
    try {
      await signInWithGoogle();
      // Page will redirect to Google — no navigate() needed
    } catch (err) {
      setError(err.message);
      setGoogleLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="form-wrap">
        <div className="form-card">
          <div className="form-head">
            <h2>Create Account</h2>
            <p>Join to start buying and selling.</p>
          </div>

          {error && <div className="alert alert-e">{error}</div>}

          <button className="btn btn-google btn-full" onClick={handleGoogle} disabled={googleLoading} type="button">
            <GoogleIcon />
            {googleLoading ? 'Redirecting…' : 'Sign up with Google'}
          </button>

          <div className="divider" style={{ margin: '1.25rem 0' }}><span>or sign up with email</span></div>

          <form onSubmit={submit}>
            <div className="fg">
              <label>Username</label>
              <input value={form.username} onChange={set('username')} placeholder="yourname" required />
            </div>
            <div className="fg">
              <label>Email</label>
              <input type="email" value={form.email} onChange={set('email')} placeholder="you@example.com" required />
            </div>
            <div className="fg">
              <label>Password</label>
              <input type="password" value={form.password} onChange={set('password')} placeholder="Min. 6 characters" required />
            </div>
            <div className="fg">
              <label>Confirm Password</label>
              <input type="password" value={form.confirm} onChange={set('confirm')} placeholder="Repeat password" required />
            </div>
            <button className="btn btn-p btn-full" type="submit" disabled={loading}>
              {loading ? 'Creating Account…' : 'Create Account'}
            </button>
          </form>

          <div className="divider" style={{ marginTop: '1.25rem' }}><span>Already have an account?</span></div>
          <div style={{ textAlign: 'center' }}>
            <Link to="/login" style={{ color: 'var(--terracotta)', fontWeight: 600, fontSize: '.9rem' }}>Sign In</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
